import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { fetchBlocsActifs } from "../store/slices/blocsReducer";
import { formatFrenchDate } from "../utils/utils";

const reviews = [
  {
    rating: 4.7,
    user: {
      name: "Alice",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=50&h=50&auto=format&fit=crop",
      date: "Juin 2025",
    },
  },
  {
    rating: 4.2,
    user: {
      name: "Bob",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=50&h=50&auto=format&fit=crop",
      date: "Juillet 2025",
    },
  },
  {
    rating: 4.5,
    user: {
      name: "Charlie",
      image: "https://images.unsplash.com/photo-1534528744316-7d86e7f8e4b8?q=80&w=50&h=50&auto=format&fit=crop",
      date: "Août 2024",
    },
  },
  {
    rating: 4.8,
    user: {
      name: "David",
      image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?q=80&w=50&h=50&auto=format&fit=crop",
      date: "Juin 2024",
    },
  },
  {
    rating: 4.3,
    user: {
      name: "Emma",
      image: "https://images.unsplash.com/photo-1517841902196-6e72f4d803e1?q=80&w=50&h=50&auto=format&fit=crop",
      date: "Juillet 2024",
    },
  },
  {
    rating: 4.6,
    user: {
      name: "Frank",
      image: "https://images.pexels.com/photos/614810/pexels-photo-614810.jpeg?auto=compress&cs=tinysrgb&w=50&h=50",
      date: "Août 2024",
    },
  },
];

const ReviewCarousel = () => {
  const trackRef = useRef(null);
  const dispatch=useDispatch()
  const {testimonials,  status, error } = useSelector((state) => state.blocs);
   useEffect(() => {
        if (status === 'idle') {
            dispatch(fetchBlocsActifs());
           
        }
    }, [dispatch, status]);
  const [isUserInteracting, setIsUserInteracting] = useState(false);

  // Duplicate reviews to create a seamless infinite effect
  const infiniteReviews = [...reviews, ...reviews];

  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    const stars = [];

    for (let i = 0; i < fullStars; i++) {
      stars.push(<span key={i} className="star full">★</span>);
    }
    if (hasHalfStar) {
      stars.push(<span key="half" className="star half">★</span>);
    }
    while (stars.length < 5) {
      stars.push(<span key={`empty-${stars.length}`} className="star empty">★</span>);
    }

    return stars;
  };

  // Highlight the center card
  const highlightCenterCard = () => {
    const track = trackRef.current;
    const cards = track.querySelectorAll(".review-card");
    const trackCenter = track?.offsetWidth / 2 + track?.scrollLeft;

    let middleCard = null;
    let minDistance = Number.MAX_VALUE;

    cards.forEach((card) => {
      const cardRect = card.getBoundingClientRect();
      const cardCenter = cardRect.left + cardRect.width / 2 + track.scrollLeft;
      const distance = Math.abs(trackCenter - cardCenter);

      if (distance < minDistance) {
        minDistance = distance;
        middleCard = card;
      }
    });

    cards.forEach((card) => card.classList.remove("highlight"));
    if (middleCard) middleCard.classList.add("highlight");
  };

  // Auto-scroll functionality
  useEffect(() => {
    const track = trackRef.current;

    const autoScroll = () => {
      if (!isUserInteracting) {
        const cardWidth = track.querySelector(".review-card")?.offsetWidth;

        // Increment scroll to simulate infinite forward scrolling
        track.scrollBy({ left: cardWidth, behavior: "smooth" });

        // Seamless looping: reset to the start when near the end
        if (track.scrollLeft >= track.scrollWidth / 2) {
          track.scrollLeft -= track.scrollWidth / 2;
        }
      }
    };

    const interval = setInterval(autoScroll, 1000); // Adjust interval as needed

    return () => clearInterval(interval);
  }, [isUserInteracting]);

  // Handle user interaction to pause auto-scroll
  useEffect(() => {
    const track = trackRef.current;

    const handleUserInteraction = () => {
      setIsUserInteracting(true);
      setTimeout(() => setIsUserInteracting(false), 1000);
    };

    track.addEventListener("scroll", handleUserInteraction);
    return () => track.removeEventListener("scroll", handleUserInteraction);
  }, []);

  // Highlight center card on scroll
  useEffect(() => {
    const track = trackRef.current;
    track.addEventListener("scroll", highlightCenterCard);

    highlightCenterCard(); // Highlight on initial render
    return () => track.removeEventListener("scroll", highlightCenterCard);
  }, []);
// console.log({testimonials})
  return (
    <div className="review-carousel">
      <div className="review-track" ref={trackRef}>
        {testimonials.avis?.map((review, index) => (
          <div className="review-card" key={index}>
            <div className="stars-rating">
              {renderStars(review.rating)}
              <span className="rating-text">{review.rating} / 5</span>
            </div>
            <div className="user-info">
              <img src={`${process.env.REACT_APP_FILE_URL}${review.avatar}`} alt={review.name} className="user-image" />
              <div className="user-details">
                <span className="user-name">{review.name}</span>
                <span className="review-date"> {formatFrenchDate(review?.review_date)}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReviewCarousel;
